/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import { Route, Switch, Link, Router } from 'react-router-dom'

import { CommonB2CProvider } from '@masfront/common-b2c'
import { history } from '@masfront/common-csr'
import { AppShell } from '@masfront/common-ui'
import LeadsPage from 'pages/LeadsPage/LeadsPage'
import { Persistor } from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'

import { Box, Button } from '@material-ui/core'

import PageNotFound from './pages/404'
import LoginPage from './pages/LoginPage'

import { AuthenticatedRoute } from '~/auth/components/AuthenticatedRoute'
import useAuth from '~/auth/hooks/useAuth'
import { AppDepsContext } from '~/core/hooks/useAppDepsContext'
import AppDeps from '~/core/model/AppDeps'
import useFeatureFlagsSync from '~/featureFlags/hooks/useFeatureFlagsSync'
import PATHS from '~/router/paths'
import Layout from '~/ui/components/Layout/Layout'
import GlobalStyles from '~/ui/GlobalStyles'
import useTheme from '~/ui/theme/useTheme'

interface AppProps {
  appDeps: AppDeps
  persistor: Persistor
}

function GoToSales() {
  return (
    <div>
      <Link to={PATHS.SALES}>
        <Button>Go to sales</Button>
      </Link>
    </div>
  )
}

export default function App({ persistor, appDeps }: AppProps) {
  const { theme } = useTheme()

  useAuth(appDeps.authService)
  useFeatureFlagsSync()

  return (
    // TODO: look for better types
    <PersistGate loading={null} persistor={persistor}>
      <AppDepsContext.Provider value={appDeps}>
        <Router history={history}>
          <AppShell theme={theme}>
            <GlobalStyles theme={theme} />
            <CommonB2CProvider>
              <Box>
                <Switch>
                  <Route exact path="/login" component={LoginPage} />
                  <Route exact path={PATHS.HOME} component={GoToSales} />
                  <AuthenticatedRoute path={PATHS.SALES}>
                    <Layout />
                  </AuthenticatedRoute>
                  <AuthenticatedRoute path={PATHS.LEADS}>
                    <LeadsPage />
                  </AuthenticatedRoute>
                  <Route component={PageNotFound} />
                </Switch>
              </Box>
            </CommonB2CProvider>
          </AppShell>
        </Router>
      </AppDepsContext.Provider>
    </PersistGate>
  )
}
